module.exports = __webpack_public_path__ + "static/media/iv_esign_top.c48b903b.svg";